import { GET_PURCHASEORDER_REQUEST, GET_PURCHASEORDER_SUCCESS, GET_PURCHASEORDER_FAIL,
    CREATE_PURCHASEORDER_REQUEST, CREATE_PURCHASEORDER_SUCCESS, CREATE_PURCHASEORDER_FAIL,
    UPDATE_PURCHASEORDER_REQUEST, UPDATE_PURCHASEORDER_SUCCESS, UPDATE_PURCHASEORDER_FAIL,
    DELETE_PURCHASEORDER_REQUEST, DELETE_PURCHASEORDER_SUCCESS, DELETE_PURCHASEORDER_FAIL  } from "../types/purchaseOrderTypes";

function deletePurchaseOrderReducer( state = { deletePurchaseOrder: {}}, action) {
    switch (action.type) {
        case DELETE_PURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_PURCHASEORDER_SUCCESS:
            return {
                ...state,
                deletePurchaseOrder: action.payload,
                isLoading: false
            }       
        case DELETE_PURCHASEORDER_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updatePurchaseOrderReducer( state = { updatePurchaseOrder: {}}, action) {
    switch (action.type) {
        case UPDATE_PURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_PURCHASEORDER_SUCCESS:
            return {
                ...state,
                updatePurchaseOrder: action.payload,
                isLoading: false
            }       
        case UPDATE_PURCHASEORDER_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function createPurchaseOrderReducer( state = { createPurchaseOrder: {}}, action) {
    switch (action.type) {
        case CREATE_PURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_PURCHASEORDER_SUCCESS:
            return {
                ...state,
                createPurchaseOrder: action.payload,
                isLoading: false
            }       
        case CREATE_PURCHASEORDER_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getPurchaseOrderReducer( state = { purchaseOrder: []}, action) {
    switch (action.type) {
        case GET_PURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PURCHASEORDER_SUCCESS:
            return {
                ...state,
                purchaseOrder: action.payload,
                isLoading: false
            }       
        case GET_PURCHASEORDER_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { getPurchaseOrderReducer, createPurchaseOrderReducer, updatePurchaseOrderReducer, deletePurchaseOrderReducer }